/**
 * 画布上的鼠标指针状态，与 KeyboardStore 同属输入设备状态，不进方案数据
 * 自己监听画布而不交给控制器：没有控制器的模式下、控制器切换前后都要持续更新
 */
export class PointerStateStore {
  private _clientX = 0;
  private _clientY = 0;
  /** PointerEvent.buttons；pointerup 时已是松手后的值 */
  private _buttons = 0;
  private _onCanvas = false;

  constructor(private _canvas: HTMLElement) {
    // pointer 事件总先于对应的 mouse 兼容事件派发，控制器在 mouse 回调里读到的已是本次位置
    for (const type of ['pointerdown', 'pointermove', 'pointerup'] as const) {
      _canvas.addEventListener(type, this.trackPointer);
    }
    _canvas.addEventListener('pointerleave', this.clearPointer);
  }

  private trackPointer = (e: PointerEvent) => {
    // 触屏、手写笔没有悬停，点完留下的位置不能当作光标所在
    if (e.pointerType !== 'mouse') {
      this._onCanvas = false;
      return;
    }

    this._clientX = e.clientX;
    this._clientY = e.clientY;
    this._buttons = e.buttons;
    this._onCanvas = true;
  };

  private clearPointer = () => {
    this._onCanvas = false;
  };

  /**
   * 供鼠标没动时重算 hover 用，按键按住时返回 null
   * 以 elementFromPoint 为准：OrbitControls 会 setPointerCapture，在画布外或覆盖层上松手时事件仍派发给画布
   */
  getIdlePointer(): Pick<PointerEvent, 'clientX' | 'clientY'> | null {
    if (!this._onCanvas || this._buttons !== 0) return null;
    if (document.elementFromPoint(this._clientX, this._clientY) !== this._canvas) return null;

    return { clientX: this._clientX, clientY: this._clientY };
  }
}
